<template>
    <div>
        <slot />
        <FooterLinks />
    </div>
</template>
<script setup>

import FooterLinks from "~/components/layouts/FooterLinks.vue"
</script>

<style scoped>
.text-footer {
    font-size: 0.9rem;
}
</style>